import React, {useEffect, useRef, useState} from 'react'
import {Col, Row} from "reactstrap";

// components
import {GenericButton} from "../../../components/buttons/customButtons";

// services
import {applicativeService} from "../../../jwt/_services/firebase/applicativeService";

const AppModule = ({
    app,
    module,
    title,
    lang,
}) => {
    const [translating, setTranslating] = useState(false)
    const [enabled, setEnabled] = useState(false)
    const isMounted = useRef(true);

    useEffect(() => {
        setEnabledStatus()

        return ()=>{
            isMounted.current = false
        }
    }, [lang, translating])

    const setEnabledStatus  = () => {
        if(translating){
            setEnabled(false)
            return
        }

        setEnabled(!!lang)
    }

    const handleTranslateModule = () => {
        const requestData = {
            'item':{
                'targetLanguage': lang,
                'applicative': app,
                'modulo': module
            }
        }

        setTranslating(true)

        applicativeService.translate(requestData)
            .then(response => {
                console.log({response})
            })
            .catch(error => { console.log("Error", error) })
            .finally(() => {
                setTranslating(false)
            })
    }


    return <Row key={module} className={'pt-1em'}>
        <Col sm={8}>
            <label>{title}</label>
        </Col>
        <Col>
            <GenericButton
                style={'secondary'}
                label={'Traducir'}
                icon={'fa-language'}
                toolTip={`Traducir ${title}`}
                disabled={!enabled}
                loading={translating}
                onClick={()=> handleTranslateModule(module)}
            />
        </Col>
    </Row>
}

export default AppModule